import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID, ViewEncapsulation, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api'; import { registerPlugin } from '@capacitor/core';
import { SwUpdate } from '@angular/service-worker'; import { Capacitor } from '@capacitor/core';
import { UpdateService } from './services/update.service'; import { App } from '@capacitor/app'; import { AuthService } from 'src/app/services/auth.service';
import { UnregisterSwService } from './services/unregister-sw/unregister-sw.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service'; import { PushService } from 'src/app/services/push.service';
import { Router, NavigationEnd } from '@angular/router'; import { MessageService } from 'primeng/api';
import { filter } from 'rxjs/operators';
import { PosthogService } from 'src/app/services/posthog.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  //encapsulation: ViewEncapsulation.ShadowDom,
})
export class AppComponent implements OnInit, AfterViewInit {

  @ViewChild('toastEl', { read: ElementRef }) toastElRef?: ElementRef<HTMLElement>;

  constructor(
    private primengConfig: PrimeNGConfig,
    private messageService: MessageService,
    private pushService: PushService,
    private router: Router,
    private authService: AuthService,
    public layoutService: LayoutService,
    private swUpdate: SwUpdate, // Injete o SwUpdate aqui
    private updateService: UpdateService,
    private unregisterSwService: UnregisterSwService,
    private renderer: Renderer2,
    private posthogService: PosthogService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.listenForSwUpdate();
    this.posthogService.init();
    this.listenForRouteChanges();
  }

  private listenForRouteChanges(): void {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.posthogService.capturePageview(event.urlAfterRedirects);
    });
  }

  // p-toast fica preso num stacking context criado por algum ancestral do layout
  // (mesmo bug do p-confirmDialog). Diferente de p-dialog/p-confirmDialog, o Toast
  // não tem [appendTo], então movemos o próprio elemento pro <body> manualmente.
  ngAfterViewInit(): void {
    if (this.toastElRef) {
      this.renderer.appendChild(document.body, this.toastElRef.nativeElement);
    }
  }

  private currentBuildTimestamp: number | null = null;

  private listenForSwUpdate(): void {
    console.log('[SW] listenForSwUpdate init — polling ngsw.json timestamp');

    fetch('/ngsw.json?nocache=' + Date.now())
      .then(res => res.json())
      .then(data => {
        this.currentBuildTimestamp = data.timestamp;
        console.log('[SW] current build timestamp:', this.currentBuildTimestamp);

        setInterval(() => {
          this.checkForNewVersion();
        }, 5 * 60 * 1000);
      })
      .catch(err => console.log('[SW] failed to fetch ngsw.json:', err));
  }

  private checkForNewVersion(): void {
    console.log('[SW] checking for new version...');
    fetch('/ngsw.json?nocache=' + Date.now())
      .then(res => res.json())
      .then(data => {
        console.log('[SW] server timestamp:', data.timestamp, '| local:', this.currentBuildTimestamp);
        if (this.currentBuildTimestamp && data.timestamp !== this.currentBuildTimestamp) {
          console.log('[SW] NEW VERSION DETECTED!');
          if (confirm('Nova versão disponível. Deseja atualizar?')) {
            // Desregistra o SW e limpa os caches antes do reload — sem isso o
            // reload pode ser respondido pelo cache da versão antiga
            this.unregisterSwService.removeServiceWorkerAndCaches()
              .finally(() => window.location.reload());
          }
        } else {
          console.log('[SW] same version, no update needed');
        }
      })
      .catch(err => console.log('[SW] check failed:', err));
  }

  async serviceWorker() {
  }
  isNativeAndroind: boolean = false;
  async ngOnInit(): Promise<void> {

    this.primengConfig.ripple = true;
    await this.serviceWorker();

    //this.updateService.initialize();


    let domain = localStorage.getItem('domain_store');
    if (domain) {
      // Quebra o domínio pelo ponto
      let parts = domain.split('.');

      // Checa se o array 'parts' possui ao menos um elemento
      if (parts.length > 0) {
        // Pega a primeira parte do domínio
        let firstPart = parts[0];

        // Define 'store_name' no localStorage usando a primeira parte do domínio
        localStorage.setItem('store_name', firstPart);
      }
    }

    if (Capacitor.isNativePlatform()) {
      this.isNativeAndroind = true;
      //this.setupAutoUpdate();
      this.handleBackButton();

      // Apenas inicializa o PushService
      await this.pushService.initPushNotifications();

      App.addListener('appUrlOpen', (data: any) => {

        const url = new URL(data.url);
        const pathParts = url.pathname.split('/').filter(Boolean);
        const integration = pathParts[1]; // "shopify", "instagram", etc.
        const result = url.searchParams.get('result');

        if (integration === 'ga4') {
          localStorage.setItem('openGa4Sidebar', '1');
        }

        if (window.location.pathname === '/apps') {
          // Força refresh mesmo se já está em /apps
          window.location.reload();
        } else {
          // Redireciona com query params para apps
          this.router.navigate(['/apps'], {
            queryParams: {
              integration,
              result,
              ts: Date.now()
            }
          });
        }

      });

    }
    console.log('teste de mensagem em app componente')
  }

  handleBackButton() {
    App.addListener('backButton', ({ canGoBack }: { canGoBack: boolean }) => {
      if (canGoBack && window.history.length > 1) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  }
  handleRefresh(event: any) {
    window.location.reload(); // Isso já recarrega a página
    event.target.complete();  // ← Nem sempre será executado, pois a página recarrega antes
  }
}

